/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBarStackedAxis: {
  name: 'bar-stacked-axis';
  data: string;
} = {
  name: 'bar-stacked-axis',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 .5a.5.5 0 0 1 .5.5v13.5h3V11a.5.5 0 0 1 1 0v3.5h8V10a.5.5 0 0 1 1 0v4.5h.5a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5V1A.5.5 0 0 1 1 .5Zm13 3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5ZM10.5 3a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0V3ZM5 5.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm5 2a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V8a.5.5 0 0 1 .5-.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
